import { DeviceIndicatorType } from "velavu-js-api";
import { makeStyleable, StyleableIcon } from "./icon-helper";
import IconLED from "../dynamicicons/icon-led";
import IconVolumeUp from "../dynamicicons/icon-volume-up";

export function getIndicateIcon(
	method: DeviceIndicatorType,
): StyleableIcon | undefined {
	switch (method) {
		case DeviceIndicatorType.LED:
			return makeStyleable(IconLED);
		case DeviceIndicatorType.Buzzer:
			return makeStyleable(IconVolumeUp);
		default:
			return undefined;
	}
}
